<template>
    <el-container class="index_box">
        <el-container>
            <!-- 顶部数据 -->
            <el-header id="elHeader" class="header_box" height='auto'>
                <div class="index_top_box">
                    <div class="imgLogo">
                        <img :src="homeLogo" alt="">
                        <span>{{ userDep }}</span>
                        <el-divider direction="vertical" v-if="shopName"></el-divider>
                        <span v-if="shopName">{{ shopName }}</span>
                        <el-divider direction="vertical"></el-divider>
                        <span>{{ userName }}</span>
                    </div>
                    <div class="index_top_right">
                        <div class="direc" v-if="wordFlag">
                            <marquee direction="left">{{ word }}</marquee>
                        </div>
                        <el-autocomplete ref="autocomplete" :highlight-first-item="true" popper-class="my-autocomplete" @focus="searchFocus" @blur="searchBlur" v-model="searchValue" :fetch-suggestions="querySearch"
                                         placeholder="试试搜索：采购" @select="handleSelect">
                            <i class="el-icon-search el-input__icon " slot="prefix">
                            </i>
                            <i class="el-icon-error el-input__icon input_icons " v-show="inputIconFlag" @click="searchValue = ''" slot="suffix">
                            </i>
                            <template slot-scope="{ item }">
                                <p class="name">{{ item.jurName }}({{ item.jurCode }})</p>
                                <span class="title">{{ item.name }}</span>
                            </template>
                        </el-autocomplete>
                        <div class="nav-li" v-if="isAIChatEnabled" @click.stop="openAIChat">
                            <el-tooltip :open-delay="500" class="item" effect="dark" content="飞凡智问" placement="bottom-end">
                                <span class="iconfont icon iconAItubiao"></span>
                            </el-tooltip>
                        </div>
                        <div class="nav-li" @click.stop="taskPanelClick">
                            <el-tooltip :open-delay="500" class="item" effect="dark" content="任务" placement="bottom-end">
                                <el-badge :hidden="taskValue == 0" :value="taskValue" :max="99" class="item">
                                    <span class="iconfont icon iconlingdang"></span>
                                </el-badge>
                            </el-tooltip>
                        </div>
                        <div class="nav-li" @click.stop="openHelp">
                            <el-tooltip :open-delay="500" class="item" effect="dark" content="帮助文档" placement="bottom-end">
                                <span class="iconfont icon iconbangzhu"></span>
                            </el-tooltip>
                        </div>
                        <div class="nav-li" @click.stop="openAbout">
                            <el-tooltip :open-delay="500" class="item" effect="dark" content="关于" placement="bottom-end">
                                <span class="iconfont icon iconguanyu"></span>
                            </el-tooltip>
                        </div>
                        <div class="nav-li" @click.stop="fullScreen">
                            <el-tooltip :open-delay="500" class="item" effect="dark" content="全屏" placement="bottom-end">
                                <span class=" icon el-icon-full-screen"></span>
                            </el-tooltip>
                        </div>
                        <div class="nav-li">
                            <span @click="logout()" class="iconfont icon icons">&#xe64c;</span>
                        </div>
                        <div class="right-menu">
                            <el-dropdown class="avatar-container" trigger="click">
                                <div class="avatar-wrapper">
                                    <img src="../assets/img/home/tx.png" class="user-avatar">
                                </div>
                                <el-dropdown-menu slot="dropdown" class="user-dropdown">
                                    <el-dropdown-item>
                                        <span @click.stop="subscriptionClick">订阅中心</span>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <span @click.stop="updatePwd">修改密码</span>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>

                    </div>
                </div>
            </el-header>
            <!-- 悬浮弹出栏目列表 -->
            <el-main class="index_body">
                <div class="tab_right">
                    <el-dropdown @command="tabSetUp">
                        <span class="el-dropdown-link">
                            <i class="el-icon-more" style="font-size: 20px;"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="tab-setup-dropdown">
                            <el-dropdown-item command="/index" :class="{ 'active': homeActionMenu == '/index' }">
                                <span class="yes">
                                    <i v-show="homeActionMenu == '/index' ? true : false" class=" icon el-icon-check"></i>
                                </span>
                                <span>首页</span>
                            </el-dropdown-item>
                            <el-dropdown-item command="/functionMenu" :class="{ 'active': homeActionMenu == '/functionMenu' }">
                                <span class="yes">
                                    <i v-show="homeActionMenu == '/functionMenu' ? true : false" class=" icon el-icon-check"></i>
                                </span>
                                <span>菜单</span>
                            </el-dropdown-item>
                            <el-dropdown-item :command="item.jurHomepage" v-for="(item, index) in saveMenuList" :key="index" :class="{ 'active': homeActionMenu == item.jurHomepage }">
                                <span class="yes">
                                    <i v-show="homeActionMenu == item.jurHomepage ? true : false" class=" icon el-icon-check"></i>
                                </span>
                                <span>{{ item.jurName }}</span>
                                <i class="el-icon-close menu-close-icon" @click.stop="delMenu(item.jurHomepage)"></i>
                            </el-dropdown-item>
                            <el-dropdown-item command="/some" :class="{ 'active': homeActionMenu == '/some' }">
                                <span class="yes">
                                    <i v-show="homeActionMenu == '/some' ? true : false" class=" icon el-icon-check"></i>
                                </span>
                                <span>关闭所有的</span>
                            </el-dropdown-item>
                            <el-dropdown-item command="/onlyOne" :class="{ 'active': homeActionMenu == '/onlyOne' }">
                                <span class="yes">
                                    <i v-show="homeActionMenu == '/onlyOne' ? true : false" class=" icon el-icon-check"></i>
                                </span>
                                <span>仅存当前的</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <el-tabs v-model="homeActionMenu" class="index_body_page" @tab-click="menuClick" @tab-remove="delMenu">
                    <!-- 行 栏目列表 -->
                    <el-tab-pane label="首页" class="index_body_content" name="/index" :closable="false">
                        <span slot="label"><i class="el-icon-s-home" style="font-size: 18px;"></i></span>
                        <!-- <webIndex ref="webIndex" @paramToHome="paramToHome"></webIndex> -->
                        <component :ref="currentComponent" :is="currentComponent" @paramToHome="paramToHome"></component>
                    </el-tab-pane>
                    <el-tab-pane label="功能" class="index_body_content " name="/functionMenu" :closable="false">
                        <span slot="label"><i class="el-icon-menu" style="font-size: 18px;"></i></span>
                        <functionMenu v-if="menuFlag" ref="functionMenu" @menuClick="handleSelect"></functionMenu>
                    </el-tab-pane>
                    <el-tab-pane v-if="homeObj.catalogue" label="目录" class="index_body_content " name="/catalogue" :closable="true">
                        <catalogue ref="catalogue" @paramToHome="paramToHome"></catalogue>
                    </el-tab-pane>
                    <el-tab-pane v-if="homeObj.homePage" label="产品宣传" class="index_body_content " name="/homePage" :closable="true">
                        <homePage ref="homePage" @paramToHome="paramToHome"></homePage>
                    </el-tab-pane>
                    <el-tab-pane v-if="homeObj.homePageDetails" label="宣传详情" class="index_body_content " name="/homePageDetails" :closable="true">
                        <homePageDetails ref="homePageDetails"></homePageDetails>
                    </el-tab-pane>
                    <el-tab-pane v-loading="flag" :closable="true" element-loading-text="加载中..." class="index_body_content" v-for="menuValue in saveMenuList" :label="menuValue.jurName" :name="menuValue.jurHomepage"
                                 :key="menuValue.jurId">
                        <iframe :src="menuValue.jurHomepage" @load="iframeLoad(menuValue.jurHomepage)" :ref="menuValue.jurHomepage" :name="menuValue.jurHomepage" :id="menuValue.jurHomepage" class="home_iframe"
                                :customAttr="JSON.stringify(earlyWarningData)"></iframe>
                    </el-tab-pane>
                </el-tabs>
            </el-main>
        </el-container>
        <!-- 穿梭框  -->
        <el-drawer v-if="isPenetrate" :close-on-press-escape="true" :visible.sync="isPenetrate" size="100%" :modal="false" :with-header="false" center :append-to-body="true">
            <div v-if="isPenetrate">
                <penetrateHome ref="penetrateHome" @setIsPenetrate="setIsPenetrate" @closeClick="closeClick">
                </penetrateHome>
            </div>
        </el-drawer>
        <!-- 收款台穿梭框  -->
        <div :style="`display: ${isCashierDrawerMinimized?'none':'block'};`" class="penetrateCashier" v-if="isCashierPenetrate">
            <div class="drawer-header">
                <div class="minimize-btn " style="background-color: #705fa1;" @click="minimizeCashierDrawer">
                    <i class="el-icon-minus"></i>
                </div>
            </div>
            <div>
                <penetrateCashier ref="penetrateCashier" :jurId="jurId" @setIsPenetrate="setIsPenetrateCashier" @closeClick="closePenetrateCashier"></penetrateCashier>
            </div>
        </div>

        <!-- 最小化状态的浮动按钮 -->
        <div v-if="isCashierDrawerMinimized" class="minimized-drawer-float" @click="restoreCashierDrawer">
            <i class="el-icon-s-unfold"></i> 收银台
        </div>
        <!-- 划价台穿梭框  -->
        <el-drawer v-else-if="isCashierPenetrateHj" :close-on-press-escape="true" :visible.sync="isCashierPenetrateHj" size="100%" :modal="false" :with-header="false" center :append-to-body="true">
            <div v-if="isCashierPenetrateHj">
                <penetrateCashierHj ref="penetrateCashierHj" :jurId="jurId" @setIsPenetrate="setIsPenetrateCashierHj" @closeClick="closePenetrateCashierHj"></penetrateCashierHj>
            </div>
        </el-drawer>
        <!-- 聊天组件 -->
        <div v-if="chatVisible">
            <chat ref="chat" @chatClose="chatClose"></chat>
        </div>
        <!-- AI助手组件 -->
        <div>
            <aiChatMange ref="aiChatMange" :visible="aiChatVisible" @closeAIChat="closeAIChat"></aiChatMange>
        </div>
        <!-- AI_OCR助手组件 -->
        <div>
            <aiOCR_recognition ref="aiOCR_recognition" @tabChange="tabChange" @paramToHome="paramToHome" :visible="aiOCRVisible" :name="OCR_NAME" @closeAIChat="closeAIChat"></aiOCR_recognition>
        </div>
        <!-- 任务面板 -->
        <div v-if="taskPanelVisible">
            <TaskPanel :taskObj="taskObj" @taskPanelClose="taskPanelClose" @getTaskParam='paramToHome'></TaskPanel>
        </div>
        <!-- 公告面板
        <div v-if="noticePanelVisible">
            <NoticePanel :noticeList="noticeList" @noticePanelClose="noticePanelClose" @freshGongGao="freshGongGao">
            </NoticePanel>
        </div> -->
        <!-- 帮助文档 -->
        <div v-if="helpDocumentVisible">
            <helpDocument ref="helpDocument" @helpClose="helpClose"></helpDocument>
        </div>
        <!-- 关于 -->
        <div v-if="showAbout">
            <versionDetail ref="versionDetail" @helpClose="showAbout = false"></versionDetail>
        </div>
        <!-- 订阅 -->
        <div v-if="subscriptionVisible">
            <SubscriptionCenter :taskObj="taskObj" @subscriptionClose="subscriptionClose" @getSubscriptionParam="getSubscriptionParam"></SubscriptionCenter>
        </div>
        <!-- 穿梭面板浮动图标 -->
        <div class="button-box" v-drag draggable="false">
            <div class="btn-bg-img" :class="{'btn-bg-img1':isAIChatEnabled}">
                <span class="el-icon-s-home" @click.stop="goPage('/index')" style="font-size: 22px;"></span>
                <span class="iconfont iconshoukuantaiguanli" @click.stop="handleSelect(jurObj)" style="font-size: 22px;"></span>
                <span class="iconfont iconAItubiao" v-if="isAIChatEnabled" @click.stop="openAIChat" style="font-size: 15px;"></span>
                <span class="el-icon-menu" @click.stop="goPage('/functionMenu')" style="font-size: 22px;"></span>
                <span class="iconfont icon-duojichuantou" @click.stop="openCt" style="font-size: 14px;"></span>
            </div>
        </div>
        <el-dialog title="修改密码" :visible.sync="updatePwdDia" width="500px" :before-close="closeClick1">
            <h4 style="color: red;" v-if="loginType">{{ loginType }}</h4>
            <el-form :model="pwd" ref="update" :rules="pwdRules">
                <el-form-item label="原密码：" prop="oldPwd" label-width="100px">
                    <el-input v-model="pwd.oldPwd" type="password" autocomplete="off" :show-password="true"></el-input>
                </el-form-item>
                <el-form-item label="新密码：" prop="newPwd" label-width="100px">
                    <el-input v-model="pwd.newPwd" type="password" autocomplete="off" :show-password="true"></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="confirmPwd" label-width="100px">
                    <el-input v-model="pwd.confirmPwd" type="password" autocomplete="off" :show-password="true"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeClick1" size='mini'>取 消</el-button>
                <el-button type="primary" @click="confirmUpdatePwd('update')" size="mini">确 定</el-button>
            </div>
        </el-dialog>
        <!-- WebSocket通知弹窗 -->
        <!-- WebSocket消息通知弹窗堆叠 -->
        <template v-if="notificationShow">
            <div v-for="(notification, index) in visibleNotifications" :key="notification.id" class="notification-panel" :style="{ bottom: `${20 + index * 220}px`, zIndex: 9999 + index }">
                <div class="panel-header">
                    <i class="el-icon-bell"></i>
                    <span>{{ notification.title || '新消息' }}</span>
                    <el-button @click="closeNotification(notification.id)" size="mini" type="text" class="close-btn">
                        <i class="el-icon-close"></i>
                    </el-button>
                </div>
                <div class="panel-content">
                    <div class="notification-body">
                        <div v-if="notification.businessId" class="message-info">
                            <div class="info-item">
                                <span class="label">单据编号:</span>
                                <span class="value">{{ notification.businessId }}</span>
                            </div>
                            <div class="info-item" v-if="notification.taskName">
                                <span class="label">任务名称:</span>
                                <span class="value">{{ notification.taskName }}</span>
                            </div>
                            <div class="info-item" v-if="notification.taskContent">
                                <span class="label">任务内容:</span>
                                <span class="value">{{ notification.taskContent }}</span>
                            </div>
                            <div class="info-item" v-if="notification.createrName">
                                <span class="label">创建人:</span>
                                <span class="value">{{ notification.createrName }}</span>
                            </div>

                            <div class="item-actions">
                                <el-button @click="handleApproval(notification)" size="mini" type="primary" icon="el-icon-check">
                                    审核
                                </el-button>
                            </div>
                        </div>
                        <div v-else class="simple-message">
                            {{ notification.content || notification.message || '暂无内容' }}
                        </div>
                    </div>

                </div>
            </div>
        </template>
        <!-- 待审核 -->
        <div class="pending-approval-panel" v-show="pendingApprovals.length > 0 && approvalPanelVisible && notificationFlagI && notificationShow">
            <div class="panel-header">
                <i class="el-icon-warning-outline"></i>
                <span>待审核任务 ({{ pendingApprovals.length }})</span>
                <el-button @click="closeApprovalPanel" size="mini" type="text" class="close-btn">
                    <i class="el-icon-close"></i>
                </el-button>
            </div>
            <div class="panel-content">
                <div class="approval-list">
                    <div v-for="(item, index) in pendingApprovals" :key="index" class="approval-item">
                        <div class="item-info">
                            <div class="document-no">
                                <span class="label">单据编号:</span>
                                <span class="value" @click="handleDetailClick(item)">{{ item.businessId }}</span>
                            </div>
                            <div class="task-name">
                                <span class="label">任务名称:</span>
                                <span class="value">{{ item.taskName }}</span>
                            </div>
                        </div>
                        <div class="item-actions">
                            <el-button @click="handleApproval(item)" size="mini" type="primary" icon="el-icon-check">
                                审核
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 待办事项弹窗 -->
        <div class="pending-todo-panel" v-show="pendingTodos.length > 0 && todoPanelVisible && notificationFlagII && notificationShow">
            <div class="panel-header">
                <i class="el-icon-s-order"></i>
                <span>待办事项 ({{ pendingTodos.length }})</span>
                <el-button @click="closeTodoPanel" size="mini" type="text" class="close-btn">
                    <i class="el-icon-close"></i>
                </el-button>
            </div>
            <div class="panel-content">
                <div class="todo-list">
                    <div v-for="(item, index) in pendingTodos" :key="index" class="todo-item">
                        <div class="item-info">
                            <div class="document-no">
                                <span class="label">单据编号:</span>
                                <span class="value" @click="handleDetailClick(item)">{{ item.businessId }}</span>
                            </div>
                            <div class="task-name">
                                <span class="label">待办事项:</span>
                                <span class="value">{{ item.businessType }}</span>
                            </div>
                        </div>
                        <div class="item-actions">
                            <el-button @click="handleTodo(item)" size="mini" type="success" icon="el-icon-right">
                                跳转
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--  代办事项-->
        <processAuditAction ref="processAuditAction"></processAuditAction>
        <audio ref="audio" src="@/assets/audio/msg.mp3"></audio>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <flowInstanceApplyAction v-if="showStatus" ref="flowInstanceApplyAction" @drawerCancel="drawerCancel" :actionData="actionData">
            </flowInstanceApplyAction>
        </el-drawer>
    </el-container>
</template>

<script>
import webIndex from "./webIndex.vue";
import webIndex1 from "./webIndex1.vue";
import homePage from "./home/homePage.vue";
import homePageDetails from "./home/homePageDetails.vue";
import catalogue from "./home/catalogue.vue";
import functionMenu from "./functionMenu.vue";
import chat from "@/byComponents/chat.vue";
import aiChatMange from "@/byComponents/aiChatMange.vue";
import aiOCR_recognition from "@/byComponents/aiOCR_recognition.vue";
import SubscriptionCenter from "../byComponents/SubscriptionCenter.vue"
import NoticePanel from "../byComponents/noticePanel.vue"
import helpDocument from "../byComponents/helpDocument.vue"
import versionDetail from "../byComponents/versionDetail.vue"
import CryptoJS from 'crypto-js'
import penetrateHome from "@/components/penetrateHome.vue"
import penetrateCashier from "@/components/penetrateCashier.vue"
import penetrateCashierHj from "@/components/penetrateCashierHj.vue"
import flowInstanceApplyAction from "@/components/flowInstanceApplyAction.vue"
export default {
    name: "home",
    components: {
        webIndex,
        webIndex1,
        homePage,
        homePageDetails,
        catalogue,
        functionMenu,
        chat,
        aiChatMange,
        aiOCR_recognition,
        SubscriptionCenter,
        NoticePanel,
        helpDocument,
        versionDetail,
        penetrateHome,
        penetrateCashier,
        penetrateCashierHj,
        flowInstanceApplyAction
    },
    data() {
        var validatePass = (rule, value, callback) => {
            // var regex = /^\S*(?=\S{8,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[!@#$%^&*? ])\S*$/
            // var test = regex.test(value);
            if (value == "") {
                callback(new Error('请输入新密码'));
            }
            // else if (!test) {
            //    callback(new Error('最少8位，包含至少1个大写字母，1个小写字母，1个数字，1个特殊字符'));
            // } 
            else {
                callback();
            }
        };
        var validatePass1 = (rule, value, callback) => {
            if (value == "") {
                callback(new Error('请再次确认密码'));
            } else if (value != this.pwd.newPwd) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            OCR_NAME: "",
            OCR_message: "",
            currentComponent: "",//控制首页
            //控制的首页---对应的子页面
            homeObj: {},
            helpDocumentVisible: false,//帮助文档
            chatVisible: false,//聊天组件
            aiChatVisible: false,//AI助手组件
            aiOCRVisible: false,//AI_OCR助手组件
            saveMenuList: [],
            homeActionMenu: "/index",
            menuList: [],
            searchList: [],//检索
            searchList1: [],
            // 用户收藏的菜单
            userMenuList: [],//收藏列表
            searchValue: "",
            taskObj: { //传递任务面板对象
                type: 'all',
            },
            taskPanelVisible: false, //任务面板
            subscriptionVisible: false, //订阅面板
            iframeData: {}, //iframe对象
            isPenetrate: false,//穿梭框
            isCashierPenetrate: false,//收款台穿梭框
            isCashierPenetrateHj: false,//划价台穿梭框
            jurId: "",
            earlyWarningData: '',
            updatePwdDia: false,
            // 抽屉是否最小化
            isCashierDrawerMinimized: false,
            pwd: {
                oldPwd: '',
                newPwd: '',
                confirmPwd: '',
                opmId: ''
            },
            pwdRules: {
                oldPwd: [{
                    required: true,
                    message: '请输入原密码',
                    trigger: 'blur'
                }],
                newPwd: [{
                    required: true,
                    trigger: 'blur',
                    validator: validatePass
                }],
                confirmPwd: [{
                    required: true,
                    validator: validatePass1,
                    trigger: 'blur'
                }],
            },
            userName: '',
            userDep: '',
            shopName: "",//门店名称
            noticeSetInterval: null, //公告定时器
            timer: null,
            //心灵鸡汤
            wordsList: window.global_config.wordsList && window.global_config.wordsList.length > 0 ? window.global_config.wordsList : [
                '梦想这东西和经典一样，永远不会因为时间而褪色，反而更显珍贵。',
                '莫找借口失败，只找理由成功。不为失败找理由，要为成功找方法。',
                '任凭风吹雨打，只要一直走下去，不放弃，远方的路终将清晰。',
                '有时候，坚持了你最不想干的事情之后，便可得到你最想要的东西。',
            ],
            wordIndex: 1,
            word: '',
            homeLogo: '',
            showAbout: false,
            //---------
            pageList: {},
            flag: true,
            inputIconFlag: false,
            menuFlag: false,
            wordFlag: true,
            //------------tab设置
            tabFlag: false,
            loginType: "",
            // WebSocket相关
            websocket: null, // 原生WebSocket实例
            socketConnected: false,
            notifications: [], // 存储通知消息
            notificationDialogVisible: false, // 通知弹窗显示状态
            currentNotification: null, // 当前显示的通知
            visibleNotifications: [], // 当前显示的通知弹窗列表
            // 待审核相关
            pendingApprovals: [], // 待审核任务列表
            approvalPanelVisible: true, // 审核面板是否显示
            // 待办事项相关
            pendingTodos: [], // 待办事项列表
            todoPanelVisible: true, // 待办面板是否显示
            // 自动关闭定时器
            approvalAutoCloseTimer: null, // 待审核弹窗自动关闭定时器
            todoAutoCloseTimer: null, // 待办事项弹窗自动关闭定时器
            notificationFlagI: true, // 待审核弹窗显示标志
            notificationFlagII: true, // 待办事项弹窗显示标志
            notificationShow: window.global_config.notificationShow,
            showStatus: false, // 详情弹窗显示状态
            actionData: {}, // 详情数据
            jurObj: { "jurId": 18000000103, "jurCode": "SKT", "jurName": "收款台", "jurStype": 2, "jurParentid": 180000001, "jurHomepage": "/cashier", "jurImg": "iconrenkuanpingtai", "jurHomeshow": 0, "actionType": 0, "isCustom": 1, "isOften": 1, "isBlock": null, "isPrint": 0, "jurSort": 1, "printSource": null, "reportId": null, "children": null, "list": [] },
        };
    },

    computed: {

        taskValue() {
            return this.$store.state.webIndexHeaderCount
        },
        // 检查 AI 聊天功能是否启用
        isAIChatEnabled() {
            return typeof window !== 'undefined' &&
                window.global_config &&
                window.global_config.AI_CHAT_URL;
        },
    },
    directives: {
        drag(el) {
            let oDiv = el // 当前元素
            // let self = this // 上下文
            // 禁止选择网页上的文字
            document.onselectstart = function () {
                return true
            }
            oDiv.onmousedown = function (e) {
                // 鼠标按下，计算当前元素距离可视区的距离
                let disX = e.clientX - oDiv.offsetLeft
                let disY = e.clientY - oDiv.offsetTop
                document.onmousemove = function (e) {
                    // 通过事件委托，计算移动的距离
                    let l = e.clientX - disX
                    let t = e.clientY - disY
                    // 移动当前元素
                    //   oDiv.style.left = l + 'px'
                    oDiv.style.top = t + 'px'
                }
                document.onmouseup = function (e) {
                    document.onmousemove = null
                    document.onmouseup = null
                }
                // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
                return false
            }
        }
    },
    mounted() {
        //初始化表情包。
        //    IMUI.initEmoji(...);
        // 接受子页面发来的信息              调用参数处理方法
        window.addEventListener("message", this.handleMessage);
        this.iframeData = this.$route.query
        window.delMenu = this.delMenu;
        window.toPages = this.toPages;
        window.getMenuInfo = this.getMenuInfo;
        // 从localStorage读取通知标志，转换为布尔值
        const flagI = sessionStorage.getItem('notificationFlagI');
        const flagII = sessionStorage.getItem('notificationFlagII');
        this.notificationFlagI = flagI === null ? true : flagI === 'true';
        this.notificationFlagII = flagII === null ? true : flagII === 'true';

        this.heightChange()
        window.addEventListener('resize', this.heightChange);
        // 请求通知权限
        this.requestNotificationPermission();
        // 初始化待审核数据
        this.loadPendingApprovals();
        // 初始化待办事项数据
        this.loadPendingTodos();
        // 查询任务数量统计
        this.queryTaskNumber();
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.LoginCheckChangePwd()
        this.currentComponent = window.global_config.currentComponent || "webIndex"
        this.getJurisdictionList();
        this.getWords()
        this.getShop()//获取当前人员绑定门店
        this.userName = JSON.parse(sessionStorage.getItem('userInfo')).opmName
        if (window.global_config.userName) {
            this.userDep = window.global_config.userName
        } else {
            this.userDep = sessionStorage.getItem('ormName')
        }
        setInterval((item) => {
            this.setUserLine()
        }, 36000);

        this.noticeSetInterval && clearInterval(this.noticeSetInterval)
        this.getHomeLogo() // logo
        if (sessionStorage.getItem('loginType')) {
            this.updatePwdDia = true
            this.loginType = sessionStorage.getItem('loginType')
        }
        if (this.notificationShow) {
            // 初始化WebSocket连接
            this.initWebSocket()
        }

    },
    beforeDestroy() {
        // 移除绑定的listenResizeFn事件监听
        window.removeEventListener("resize", this.heightChange);
        window.removeEventListener("message", this.handleMessage);
        // 断开WebSocket连接
        this.disconnectWebSocket();
    },
    methods: {
        async LoginCheckChangePwd() {
            const res = await this.$http.LoginCheckChangePwd()
            if (res.status == 200) {

            } else if (res.status == 500) {
                this.loginType = res.message
                sessionStorage.setItem("loginType", res.message)
                this.updatePwd()
                return
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                });
            }
        },
        async getShop() {
            this.shopName = ""
            const res = await this.$http.storemastgetCurStore()
            if (res.status == 200) {
                this.shopName = res.result.storeName || "",
                sessionStorage.setItem('shopInfo',JSON.stringify(res.result))
            }
        },
        drawerCancel() {
            this.showStatus = false
        },
        // 点击穿透字段 传参单号
        async toDetail(orderId) {
            if (orderId) {
                try {
                    // 先验证数据是否存在
                    let responseData = await this.$http.getPenetrateData({ ids: [orderId] });
                    if (responseData.status == 200) {
                        var res = responseData.result;
                        if (!res || Object.keys(res).length === 0) {
                            this.$message({
                                message: "穿梭框暂无数据",
                                type: "error",
                            });
                            return;
                        }

                        // 数据验证通过，打开穿透组件首页
                        var isPenetrate = true;
                        // 设置缓存 存入点击单号
                        this.resetSetItem("penetrateOrderId", orderId);
                        // 与父级跨域通信 传递isPenetrate参数
                        window.parent.postMessage(
                            {
                                //向窗口发送MessageEvent消息
                                cmd: "returnFormJson",
                                params: { isPenetrate }, //参数
                            },
                            "*"
                        );
                    } else {
                        this.$message({
                            message: responseData.message || "获取数据失败",
                            type: "error",
                        });
                    }
                } catch (error) {
                    console.error('获取穿透数据失败:', error);
                    this.$message({
                        message: "获取数据失败，请稍后重试",
                        type: "error",
                    });
                }
            }
        },
        closeClick1() {
            console.log(sessionStorage.getItem('loginType'));

            if (sessionStorage.getItem('loginType')) {
                this.$alert('请先修改密码，才能退出', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.updatePwdDia = true
                    }
                });

            } else {
                sessionStorage.removeItem("loginType")
                this.updatePwdDia = false
            }
        },
        goPage(line) {
            this.homeActionMenu = line
            this.menuClick()
        },
        //关闭所有的
        tabSetUp(index) {
            if (index == '/some') {
                this.saveMenuList = []
                this.homeActionMenu = '/index'
            } else if (index == '/onlyOne') {
                var obj = JSON.parse(JSON.stringify(this.tabSelect(this.homeActionMenu)))
                if (obj) {
                    this.saveMenuList = [obj]
                } else {
                    this.saveMenuList = []
                }
                return
            } else if (index == '/index') {
                this.homeActionMenu = '/index'
            } else if (index == '/functionMenu') {
                this.homeActionMenu = '/functionMenu'
                if (this.homeActionMenu == '/functionMenu') {
                    this.$nextTick(() => {
                        this.$refs['functionMenu'].openBox()
                    })
                }
            } else {
                this.homeActionMenu = index
                this.toPages(this.tabSelect(this.homeActionMenu));
            }
        },
        tabSelect(val) {
            var obj = ""
            this.saveMenuList.forEach(item => {
                if (item.jurHomepage == val) {
                    obj = item
                }
            })
            return obj
        },
        //调用浏览器全屏方法
        fullScreen() {
            if (!document.fullscreenElement) {
                this.enterFullScreen();
            } else {
                this.exitFullScreen();
            }
        },
        enterFullScreen() {
            let element = document.documentElement;
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) { /* Firefox */
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) { /* IE/Edge */
                element.msRequestFullscreen();
            }
        },
        exitFullScreen() {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) { /* Firefox */
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { /* IE/Edge */
                document.msExitFullscreen();
            }
        },
        heightChange() {
            if (document.documentElement.clientWidth <= 1130) {
                this.wordFlag = false
            } else {
                this.wordFlag = true
            }
        },
        searchFocus() {
            this.searchList = JSON.parse(JSON.stringify(this.searchList1))
            this.inputIconFlag = true
        },
        searchBlur() {
            this.searchList = []
            setTimeout(() => {
                this.inputIconFlag = false

            }, 200)
        },
        menuClick() {
            console.log("toPage", this.homeActionMenu);
            var obj = this.tabSelect(this.homeActionMenu)
            if (obj) {
                this.toPages(obj);
            } else {
                if (this.homeActionMenu == '/functionMenu') {
                    this.$nextTick(() => {
                        this.$refs['functionMenu'].openBox()
                    })
                } else if (this.homeActionMenu == '/index') {
                    this.$nextTick(() => {
                        this.$refs[this.currentComponent].openBox()
                    })
                }
            }

        },
        //iframe Loading加载
        iframeLoad(val) {
            this.query_AI(val)
            this.flag = false
        },
        querySearch(queryString, cb) {
            var restaurants = this.searchList;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.jurName.toLowerCase().indexOf(queryString.toLowerCase()) >= 0 || (restaurant.jurCode && restaurant.jurCode.toLowerCase().indexOf(queryString.toLowerCase()) >= 0));
            };
        },
        handleSelect(item) {
            console.log(item);
            this.$refs['autocomplete'].$refs.input.blur()
            this.searchValue = ""
            this.jurId = item.jurId
            sessionStorage.removeItem("savePage");
            if (item.jurHomepage == '/cashier') {
                // 路由是收款台，需要跳转到全屏穿梭框组件
                console.log('/penetrateCashier', "收银台");
                this.isCashierPenetrate = true
            } else if (item.jurHomepage == '/cashierHj') {
                console.log('/penetrateCashierHj', "划价台");

                // 路由是划价台，需要跳转到全屏穿梭框组件
                this.isCashierPenetrateHj = true
            } else if (item.jurHomepage == '/firstGoods') {
                this.OCR_NAME = '商品'
                this.aiOCRVisible = true
            } else if (item.jurHomepage == '/firstCustomer') {
                this.OCR_NAME = '客户'
                this.aiOCRVisible = true
            } else if (item.jurHomepage == '/firstSupplier') {
                this.OCR_NAME = '供应商'
                this.aiOCRVisible = true
            } else {
                this.toPages(item);

            }

        },
        getMenuInfo(path) {
            return JSON.parse(sessionStorage.getItem("savePage"))
            if (this.pageList.jurHomepage == path) {
                return this.pageList;
            } else {
                return ""
            }
        },
        //跳转地址数据解析
        toPages(pageData) {
            this.menuRecordAddMenuRecord(pageData)
            console.log('toPages', pageData);
            console.log('toPages', pageData.jurHomepage);
            // 点击其他页面 关闭穿透组件首页
            this.isPenetrate = false;
            sessionStorage.removeItem("printJurId");
            sessionStorage.removeItem("printSource");
            sessionStorage.removeItem("reportId");
            sessionStorage.setItem("printJurId", JSON.stringify(pageData.jurId));
            sessionStorage.setItem("printSource", JSON.stringify(pageData.printSource));
            sessionStorage.setItem("reportId", JSON.stringify(pageData.reportId));
            sessionStorage.setItem("savePage", JSON.stringify(pageData));
            this.pageList = pageData
            var sessionName = pageData.jurParentid;
            sessionStorage.setItem(sessionName, JSON.stringify(pageData));
            var saveMenuList = this.saveMenuList;
            var isNext = true;
            saveMenuList.forEach((saveValue, saveKey) => {
                if (saveValue.jurId == pageData.jurId) {
                    this.homeActionMenu = pageData.jurHomepage;
                    isNext = false;
                }
            });
            if (isNext == false) {
                return false;
            } else {
                this.flag = true
            }
            if (saveMenuList.length >= 20) {
                this.$message({
                    message: "您已经打开二十个模块了，请先关闭其它无操作的模块",
                    type: "error",
                });
                return false;
            }
            saveMenuList.push(pageData);
            this.homeActionMenu = pageData.jurHomepage;
        },
        tabChange(val) {
            if (document.getElementById(val.path)) {
                this.homeActionMenu = val.path
                this.menuClick()
                setTimeout(() => {
                    this.$nextTick(() => {
                        const iframe = document.getElementById(val.path);
                        iframe.contentWindow.postMessage({ type: 'OCR_message', data: val.query }, '*');
                    })
                }, 500);
            } else {
                this.paramToHome(val.path)
                this.OCR_message = val.query
            }

        },
        query_AI(val) {
            if (val == '/firstGoodsList' || val == '/firstCustomerList' || val == '/firstSupplierList') {
                setTimeout(() => {
                    if (document.getElementById(val)) {
                        this.$nextTick(() => {
                            const iframe = document.getElementById(val);
                            iframe.contentWindow.postMessage({ type: 'OCR_message', data: this.OCR_message }, '*');
                            this.OCR_message = ""
                        })
                    } else {
                        this.query_AI(val)
                    }
                }, 100);
            }
        },
        menuRecordAddMenuRecord(val) {
            this.$http.menuRecordAddMenuRecord({ ids: [val.jurId] }).then(res => {
                console.log(res);
            })
        },
        // 删除模块菜单
        delMenu(targetName) {
            console.log(targetName);
            let tabs = this.saveMenuList;
            let index = tabs.findIndex(element => element.jurHomepage === targetName);//删除时savePage需要更新
            console.log(index)
            if (index >= 1) {
                if (index < (tabs.length - 1)) {
                    sessionStorage.setItem("savePage", JSON.stringify(this.saveMenuList[index + 1]));
                    sessionStorage.setItem("reportId", JSON.stringify(this.saveMenuList[index + 1].reportId));
                } else {
                    sessionStorage.setItem("savePage", JSON.stringify(this.saveMenuList[index - 1]));
                    sessionStorage.setItem("reportId", JSON.stringify(this.saveMenuList[index - 1].reportId));
                }
            } else if (index == 0) {
                if (this.saveMenuList.length > 1) {
                    sessionStorage.setItem("savePage", JSON.stringify(this.saveMenuList[index + 1]));
                    sessionStorage.setItem("reportId", JSON.stringify(this.saveMenuList[index + 1].reportId));
                }
            } else {
                this.$set(this.homeObj, targetName.split('/')[1], false)
            }

            let activeName = this.homeActionMenu;
            tabs.forEach((tab, index) => {
                if (tab.jurHomepage == targetName) {
                    let nextTab = tabs[index + 1] || tabs[index - 1];
                    if (nextTab) {
                        activeName = nextTab.jurHomepage;
                    }
                }
            });

            this.saveMenuList = tabs.filter((tab) => tab.jurHomepage != targetName);
            this.homeActionMenu =
                this.saveMenuList.length >= 1 ? activeName : "/index";
            var newMenu = this.saveMenuList;
            sessionStorage.setItem("saveMenuList", JSON.stringify(newMenu));
            var ed = ''
            window.parent.postMessage(
                {
                    //向窗口发送MessageEvent消息
                    cmd: "returnData",
                    params: { ed }, //参数
                },
                "*"
            );
        },
        //---------------------------------------------------
        //关于组件
        openAbout() {
            this.showAbout = true
        },
        // 打开AI助手
        openAIChat() {
            this.aiChatVisible = true
        },
        // 关闭AI助手
        closeAIChat() {
            this.aiChatVisible = false
            this.aiOCRVisible = false
        },
        //聊天组件关闭
        chatClose(status) {
            this.chatVisible = status
        },
        //聊天组件打开
        openCaht() {
            this.chatVisible = true
        },
        //帮助文党打开
        openHelp() {
            this.helpDocumentVisible = true
        },
        // 打开修改密码框
        updatePwd() {
            for (let key in this.pwd) {
                this.pwd[key] = ''
            }
            this.updatePwdDia = true
        },
        // 修改密码
        confirmUpdatePwd(update) {
            this.$refs[update].validate((valid) => {
                if (valid) {
                    this.subPwd()
                } else {
                    return false;
                }
            });
        },
        //保存密码
        async subPwd() {
            var key = CryptoJS.enc.Utf8.parse('dfsoft.soft.1501');//秘钥
            // // 要加密的字符串
            let params = JSON.parse(JSON.stringify(this.pwd))
            params.oldPwd = CryptoJS.AES.encrypt(String(this.pwd.oldPwd), key, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }).toString();
            params.newPwd = CryptoJS.AES.encrypt(String(this.pwd.newPwd), key, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }).toString();
            params.confirmPwd = CryptoJS.AES.encrypt(String(this.pwd.confirmPwd), key, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }).toString();
            params.opmId = JSON.parse(sessionStorage.getItem('userInfo')).opmId
            let responseData = await this.$http.updatePwd(params);
            if (responseData.status == 200) {
                this.$message({
                    type: "success",
                    message: "修改成功",
                });
                this.updatePwdDia = false
                sessionStorage.clear()
                //清除所有的缓存
                this.$common.pageJump("/login");
                this.$common.remove()


            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //任务跳转传来数据
        paramToHome(e, flag, obj) {
            if (flag) {
                this.$set(this.homeObj, e.split('/')[1], true)
                this.homeActionMenu = e
                console.log(obj.item, "测试");

                this.$nextTick(() => {
                    this.$refs[e.split('/')[1]].openBox(obj.item)
                })
                return
            }
            this.earlyWarningData = e
            this.earlyWarningPathChange(e)
            var postPath = e
            this.taskPanelVisible = false
            setTimeout(() => {
                this.getHomePage(postPath)
            }, 500)
        },
        //检索要跳转的页面
        async getHomePage(e) {
            var postPath = e
            this.$nextTick(() => {
                try {
                    let iframeWin = this.$refs[postPath][0].contentWindow; ///dataQuery
                    iframeWin.postMessage({
                        cmd: 'getFormJson',
                        params: {
                            postPath
                        }
                    }, '*');
                } catch (error) {
                    this.$message.error('暂无此权限,请去申请!')
                }
            })
        },
        //  单据再现组件 回调isPenetrate参数
        setIsPenetrate(val) {
            this.isPenetrate = val
        },
        // 收款台穿梭框 回调isCashierPenetrate参数
        setIsPenetrateCashier(val) {
            this.isCashierPenetrate = val
        },
        // 划价台穿梭框 回调isCashierPenetrateHj参数
        setIsPenetrateCashierHj(val) {
            this.isCashierPenetrateHj = val
        },
        // 收款台穿梭框 关闭
        closePenetrateCashier(val) {
            this.isCashierPenetrate = false
        },
        // 划价台穿梭框 关闭
        closePenetrateCashierHj(val) {
            this.isCashierPenetrateHj = false
        },
        // 收款台抽屉最小化
        minimizeCashierDrawer() {
            this.isCashierDrawerMinimized = true;
            this.$refs['penetrateCashier'].closeClick();
        },
        // 恢复收款台抽屉
        restoreCashierDrawer() {
            this.isCashierDrawerMinimized = false;
            this.$refs['penetrateCashier'].openClick();
        },
        // 穿梭框 关闭
        closeClick(val) {
            this.$message.error(val)
            this.isPenetrate = false
        },
        //接受子页面返回来的数据
        async handleMessage(event) {
            var data = event.data;
            if (typeof data == 'string') {
                if (data.indexOf('[') != -1) this.toPages(JSON.parse(data))
            } else {
                switch (data.cmd) {
                    // 与子组件传递信息cmd对比
                    case 'returnFormJson':
                        // 处理业务逻辑
                        //参数赋值给当前页面变量
                        var orderId = sessionStorage.getItem('penetrateOrderId')
                        if (orderId != 'null') {
                            this.isPenetrate = data.params.isPenetrate
                        } else {
                            this.$message({
                                message: '暂无跳转数据',
                                type: 'error'
                            });
                        }
                        break;
                    case 'returnData':
                        this.earlyWarningData = data.params.ed
                        break;
                    case 'toOtherPage': // 跳转页面
                        // this.istoSalesman = data.params.istoSalesman
                        this.paramToHome(data.params.pagePath)
                        break
                    case "getFormJson":
                        this.iframeSrc.iframeSrc = data.params.postPath
                        break
                    case "login":
                        this.$message.error(data.message)
                        this.$common.pageJump('./login')
                        break
                }
            }
        },
        //穿梭框按钮
        openCt() {
            if (sessionStorage.getItem('tabData') && JSON.parse(sessionStorage.getItem('tabData')).length != 0) {
                this.isPenetrate = true
            } else {
                return this.$notify({
                    title: '提示',
                    message: '暂无穿梭单据数据',
                    type: 'warning',
                    position: 'bottom-right'
                });
            }
        },
        // 打开聊天组件 调用聊天组件内部方法
        openLemo() {
            this.$refs['chat'].openLemo()
        },
        onBtnClicked() {
            this.$emit("onFloatBtnClicked")
        },
        handleScrollStart() {
            this.timer && clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                this.handleScrollEnd()
            }, 300)
            this.currentTop = document.documentElement.scrollTop || document.body.scrollTop
            if (this.left > this.clientWidth / 2) {
                this.left = this.clientWidth - this.itemWidth / 2
            } else {
                this.left = -this.itemWidth / 2
            }
        },
        handleScrollEnd() {
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            if (scrollTop === this.currentTop) {
                if (this.left > this.clientWidth / 2) {
                    this.left = this.clientWidth - this.itemWidth - this.gapWidth
                } else {
                    this.left = this.gapWidth
                }
                clearTimeout(this.timer)
            }
        },
        //路径改变页面
        earlyWarningPathChange(str) {
            if (!str || str == '') return false
            let childData = this.getMenuData(str, this.menuList, true)
            if (childData) {
                this.toPages(childData)
            }
        },
        //递归查找目录对象
        getMenuData(str, list, type) {
            if (type) {
                for (const v of list || []) {
                    if (v.jurHomepage == str) return v
                    const v_v = this.getMenuData(str, v.list, true)
                    if (v_v) return v_v
                }
            } else {
                for (const v of list || []) {
                    if (v.jurId == str.jurParentid) return v
                    const v_v = this.getMenuData(str, v.list)
                    if (v_v) return v_v
                }
            }
        },

        //订阅
        subscriptionClick() {
            this.subscriptionVisible = true
        },
        subscriptionClose(changeData) { //status 关闭订阅  //订阅类型0.任务1.板块2.预警\
            changeData.type.forEach((v) => {
                switch (v) {
                    case 0:
                        this.$refs['webIndex'].getPanelList() //获取头部任务列表
                        break;
                    case 1:
                        this.$refs['webIndex'].getSubscribePlate() //查询当前用户的板块订阅信息
                        break;
                    case 2:
                        this.$refs['webIndex'].getEarlyWarningList() //获取预警菜单
                        break;

                    default:
                        break;
                }
            })

            // if(changeData) this.$router.go(0)
            this.subscriptionVisible = changeData.status
        },
        //订阅跳转传来数据
        getSubscriptionParam(e) {
            this.earlyWarningData = e
            this.earlyWarningPathChange(e)
            var postPath = e
            this.taskPanelVisible = false
            this.getHomePage(postPath)
        },

        //调取任务面板
        taskPanelClick() {
            this.taskPanelVisible = true
        },
        taskPanelClose(status) { //status 关闭面板
            this.taskPanelVisible = status
            // !this.taskPanelVisible && this.getPanelList()
        },
        // 关闭帮助文档
        helpClose(status) { //status 关闭面板
            this.helpDocumentVisible = status
        },
        // 退出登录
        logout() {
            this.$confirm('确定退出登录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteUserBillNum()
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        async deleteUserBillNum() {
            const responseData = await this.$http.deleteUserBillNum()
            if (responseData.status == 200) {
                this.loginOutFun()
            }
        },
        async loginOutFun() {
            let responseData = await this.$http.loginOut();
            if (responseData.status == 200) {
                sessionStorage.clear()
                //清除所有的缓存
                this.$common.remove()
                this.$common.pageJump("/login");
                this.$message({
                    type: 'success',
                    message: '已退出登录'
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 更改用户在线时间
        async setUserLine() {
            if (sessionStorage.getItem('userInfo')) {
                let responseData = await this.$http.setUserLine({
                    ids: [this.$store.getters.getUserInfo.opmId],
                });
                if (responseData.status == 200) { } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }


        },

        // 获取用户收藏的菜单
        async getUserMenu(id) {
            let responseData = await this.$http.getUserMenu({
                ids: [this.$store.getters.getUserInfo.opmId],
            });
            if (responseData.status == 200) {
                this.userMenuList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 获取权限
        async getJurisdictionList() {
            var dataInfo = this.$store.getters.getUserInfo;
            let responseData = await this.$http.getUserJurisdiction({
                jurType: 0, //	权限类型权限类型0.erp1.协同
                opmId: dataInfo.opmId, //	id列表
            })
            if (responseData && responseData.status == 200) {
                var list = this.handleJurisdiction(responseData.result);
                sessionStorage.setItem("webMenuList", JSON.stringify(list));
                sessionStorage.setItem("webList", JSON.stringify(responseData.result));
                this.menuList = list;
                this.searchList = []
                this.searchList1 = []
                this.menuList.forEach(item => {
                    if (item.list && item.list.length > 0) {
                        item.list.forEach(item1 => {
                            if (item1.list && item1.list.length > 0) {
                                item1.list.forEach(item2 => {
                                    item2.value = item2.jurName
                                    item2.name = `${item.jurName} / ${item1.jurName} / ${item2.jurName}`
                                    this.searchList.push(item2)
                                    this.searchList1.push(item2)
                                })
                            }
                        })
                    }
                })
                this.menuFlag = true
                this.getUserMenu();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 权限处理
        handleJurisdiction(data, id = 0, lev = 0) {
            var son = [];
            data.forEach((value, keys) => {
                if (value["jurParentid"] == id) {
                    if (value["urlStype"] == 1) {
                        value["selectedStatus"] = 0;
                    }
                    value["list"] = this.handleJurisdiction(
                        data,
                        value["jurId"],
                        lev + 1
                    );

                    son.push(value);
                }
            });
            return son;
        },

        // 权限处理
        handleJurisdictionTwo(data, id = 0, lev = 0) {
            var son = [];
            data.forEach((value, keys) => {
                if (lev <= 2) {
                    if (value["jurParentid"] == id) {
                        // if(value['jurId'] == this.sendDataInfo.jurId){
                        // 	value['disabled'] = true;
                        // }
                        value["value"] = value["jurId"];
                        value["label"] = value["jurName"];
                        value["lev"] = lev;
                        // if(value['jurStype']>=3){
                        // 	value['disabled'] = true;
                        // }
                        var list = this.handleJurisdictionTwo(
                            data,
                            value["jurId"],
                            lev + 1
                        );
                        if (list.length >= 1) {
                            value["children"] = this.handleJurisdictionTwo(
                                data,
                                value["jurId"],
                                lev + 1
                            );
                        }

                        son.push(value);
                    }
                }
            });
            return son;
        },
        // 鸡汤
        getWords() {
            this.word = this.wordsList[0]
            this.timer = setInterval(() => {
                if (this.wordIndex >= this.wordsList.length) {
                    this.wordIndex = 0
                    this.word = this.wordsList[0]
                    return
                } else {
                    this.word = this.wordsList[this.wordIndex]
                    this.wordIndex++
                }
            }, 300000)
        },
        getHomeLogo() {
            if (sessionStorage.getItem('homeLogo') &&
                sessionStorage.getItem('homeLogo') != '' &&
                sessionStorage.getItem('homeLogo') != null &&
                sessionStorage.getItem('homeLogo') != undefined
            ) {
                this.homeLogo = sessionStorage.getItem('homeLogo')
            }
        },

        // WebSocket相关方法
        initWebSocket() {
            try {
                // 获取当前用户ID
                const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                const userId = userInfo ? userInfo.opmId : ""
                // 使用原生WebSocket连接
                const wsUrl = `${window.global_config.BASE_URL}/ws?userId=${userId}`
                this.websocket = new WebSocket(wsUrl)
                // 连接成功事件
                this.websocket.onopen = (event) => {
                    console.log('WebSocket连接成功:', event)
                    this.socketConnected = true
                    // 发送订阅消息
                    const subscribeMessage = {
                        action: 'subscribe',
                        userId: userId,
                        channel: '/user/queue/approval/notifications'
                    }
                    this.sendWebSocketMessage(subscribeMessage)
                }
                // 接收消息事件
                this.websocket.onmessage = (event) => {
                    try {
                        const notification = JSON.parse(event.data)
                        this.handleNotification(notification)
                    } catch (error) {
                        console.error('消息解析失败:', error)
                    }
                }

                // 连接错误事件
                this.websocket.onerror = (error) => {

                    this.socketConnected = false

                }

                // 连接关闭事件
                this.websocket.onclose = (event) => {
                    console.log('WebSocket连接已关闭:', event.code, event.reason)
                    this.socketConnected = false

                    // 如果不是主动关闭，则尝试重连
                    if (event.code !== 1000) {
                        console.log('连接异常关闭，5秒后尝试重连...')
                        setTimeout(() => {
                            this.initWebSocket()
                        }, 5000)
                    }
                }

            } catch (error) {
                console.error('WebSocket初始化失败:', error)
                // this.$message.error('WebSocket初始化失败')
            }
        },

        // 发送WebSocket消息
        sendWebSocketMessage(message) {
            if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
                try {
                    const messageStr = JSON.stringify(message)
                    this.websocket.send(messageStr)
                    console.log('WebSocket消息发送成功:', message)
                } catch (error) {
                    console.error('WebSocket消息发送失败:', error)
                }
            } else {
                console.warn('WebSocket未连接，无法发送消息')
            }
        },

        // 断开WebSocket连接
        disconnectWebSocket() {
            if (this.websocket) {
                console.log('主动断开WebSocket连接')
                this.websocket.close(1000, '主动断开连接')
                this.websocket = null
                this.socketConnected = false
            }
        },

        // 检查WebSocket连接状态
        checkWebSocketConnection() {
            if (!this.websocket || this.websocket.readyState !== WebSocket.OPEN) {
                console.log('WebSocket未连接，尝试重新连接...')
                this.initWebSocket()
                return false
            }
            return true
        },

        handleNotification(notification) {
            console.log('收到WebSocket消息:', notification)

            // 检查notification是否为空
            if (!notification || Object.keys(notification).length === 0) {
                console.log('notification为空，跳过弹窗显示')
                this.notificationDialogVisible = false
                return
            }

            // 创建通知对象
            const notificationObj = {
                ...notification,
                id: Date.now() + Math.random(), // 确保唯一ID
                timestamp: new Date().toLocaleString(),
                read: false
            }

            // 添加到通知列表
            this.notifications.unshift(notificationObj)

            // 播放提示音
            this.playNotificationSound()

            // 显示通知
            this.showNotification(notificationObj)

            // 添加到可见通知列表（堆叠显示）
            this.addVisibleNotification(notificationObj)
        },

        showNotification(notification) {
            // 使用浏览器通知
            if (Notification.permission === "granted") {
                new Notification(notification.title || '新消息', {
                    body: notification.content || notification.message,
                    icon: '/favicon.ico',
                    tag: 'approval-notification'
                })
            } else if (Notification.permission !== "denied") {
                Notification.requestPermission().then(permission => {
                    if (permission === "granted") {
                        new Notification(notification.title || '新消息', {
                            body: notification.content || notification.message,
                            icon: '/favicon.ico',
                            tag: 'approval-notification'
                        })
                    }
                })
            }
        },




        playNotificationSound() {
            try {
                if (this.$refs.audio) {
                    this.$refs.audio.play()
                }
            } catch (error) {
                console.log('播放提示音失败:', error)
            }
        },

        closeNotificationDialog() {
            this.notificationDialogVisible = false
            this.currentNotification = null
        },

        // 添加可见通知到堆叠列表
        addVisibleNotification(notification) {
            // 检查是否有待审核或待办事项弹窗正在显示
            const hasApprovalPanel = this.pendingApprovals.length > 0 && this.approvalPanelVisible && this.notificationFlagI
            const hasTodoPanel = this.pendingTodos.length > 0 && this.todoPanelVisible && this.notificationFlagII

            if (hasApprovalPanel || hasTodoPanel) {
                console.log('待审核或待办事项弹窗正在显示，WebSocket通知弹窗暂不显示')
                return
            }

            // 添加到可见通知列表
            this.visibleNotifications.unshift(notification)

            // 限制最多显示3个通知弹窗
            if (this.visibleNotifications.length > 3) {
                this.visibleNotifications = this.visibleNotifications.slice(0, 3)
            }

            // 设置自动关闭定时器（120000秒后自动关闭）
            setTimeout(() => {
                this.closeNotification(notification.id)
            }, 120000)
        },

        // 关闭指定的通知弹窗
        closeNotification(notificationId) {
            const index = this.visibleNotifications.findIndex(n => n.id === notificationId)
            if (index > -1) {
                this.visibleNotifications.splice(index, 1)
            }
        },

        // 关闭所有通知弹窗
        closeAllNotifications() {
            this.visibleNotifications = []
        },



        // 请求通知权限
        requestNotificationPermission() {
            if ('Notification' in window && Notification.permission === 'default') {
                Notification.requestPermission()
            }
        },

        // 测试WebSocket消息推送功能
        testWebSocketMessage() {
            // 检查连接状态
            if (!this.checkWebSocketConnection()) {
                this.$message.warning('WebSocket未连接，无法发送测试消息')
                return
            }

            // 发送测试消息到服务器
            const testMessage = {
                action: 'test',
                userId: JSON.parse(sessionStorage.getItem('userInfo') || '{}').opmId || '',
                message: '测试WebSocket连接'
            }
            this.sendWebSocketMessage(testMessage)

            // 同时模拟接收到的通知消息
            const testNotification = {
                title: '测试消息',
                content: '这是一条测试的WebSocket消息推送',
                type: 'test',
                timestamp: new Date().toLocaleString()
            }
            this.handleNotification(testNotification)
            this.$message.info('已发送测试消息')
        },

        // 待审核相关方法
        closeApprovalPanel() {
            sessionStorage.setItem('notificationFlagI', false);
            this.notificationFlagI = false;
            this.approvalPanelVisible = false
            // 清除自动关闭定时器
            if (this.approvalAutoCloseTimer) {
                clearTimeout(this.approvalAutoCloseTimer)
                this.approvalAutoCloseTimer = null
            }

        },

        showApprovalPanel() {
            this.approvalPanelVisible = true
            // 显示待审核弹窗时隐藏WebSocket通知弹窗
            this.notificationDialogVisible = false
            // 设置2分钟后自动关闭
            this.startApprovalAutoCloseTimer()
        },

        // 启动待审核弹窗自动关闭定时器
        startApprovalAutoCloseTimer() {
            // 清除之前的定时器
            if (this.approvalAutoCloseTimer) {
                clearTimeout(this.approvalAutoCloseTimer)
            }
            // 设置2分钟(120秒)后自动关闭
            this.approvalAutoCloseTimer = setTimeout(() => {
                if (this.approvalPanelVisible) {
                    this.closeApprovalPanel()
                    console.log('待审核弹窗已自动关闭')
                }
            }, 120000) // 2分钟 = 120000毫秒
        },

        // 待办事项相关方法
        closeTodoPanel() {
            sessionStorage.setItem('notificationFlagII', false);
            this.notificationFlagII = false;
            this.todoPanelVisible = false
            // 清除自动关闭定时器
            if (this.todoAutoCloseTimer) {
                clearTimeout(this.todoAutoCloseTimer)
                this.todoAutoCloseTimer = null
            }

        },
        showTodoPanel() {
            this.todoPanelVisible = true
            // 显示待办事项弹窗时隐藏WebSocket通知弹窗
            this.notificationDialogVisible = false
            // 设置2分钟后自动关闭
            this.startTodoAutoCloseTimer()
        },
        // 启动待办事项弹窗自动关闭定时器
        startTodoAutoCloseTimer() {
            // 清除之前的定时器
            if (this.todoAutoCloseTimer) {
                clearTimeout(this.todoAutoCloseTimer)
            }
            // 设置2分钟(120秒)后自动关闭
            this.todoAutoCloseTimer = setTimeout(() => {
                if (this.todoPanelVisible) {
                    this.closeTodoPanel()
                    console.log('待办事项弹窗已自动关闭')
                }
            }, 120000) // 2分钟 = 120000毫秒
        },
        handleTodo(item) {
            this.paramToHome(item.targetPath)
        },
        handleApproval(item) {
            console.log(item);

            if (item.taskMode == 1) {
                this.lookDetail(item);
            } else {
                this.$refs["processAuditAction"].openBox(0, [item.businessId]);
                this.$refs["processAuditAction"].dealTitle(item);
            }
        },
        // 处理详情点击，根据taskMode判断调用不同方法
        handleDetailClick(item) {
            console.log(item, 'item')
            if (item.taskMode == 1) {
                this.lookDetail(item, true);
            } else {
                this.toDetail(item.businessId);
            }
        },
        // 查看详情方法（当taskMode == 1时调用）
        lookDetail(row, flag) {
            this.queryDetails(row, flag);
        },
        // 查询详情数据
        async queryDetails(row, flag) {
            try {
                const res = await this.$http.flowInstancequeryInfo({ ids: [row.businessId] });
                if (res.status == 200) {
                    let responseData = await this.$http.flowDeinitqueryDeinitionById({ ids: [res.result.wfdId] });
                    if (responseData && responseData.status == 200) {
                        this.actionData = {
                            cate: 4,
                            wfdId: row.businessId,
                            wfiId: res.result.wfiId,
                            wdfForm: responseData.result.wdfForm,
                            wfiContent: res.result.wfiContent,
                            wfdName: res.result.wfdName,
                            wfiRemark: res.result.wfiRemark,
                        };
                        if (flag) {
                            this.actionData.cate = 2;
                        }
                        this.showStatus = true;
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                }
            } catch (error) {
                console.error('查询详情失败:', error);
                this.$message({
                    message: '查询详情失败',
                    type: "error",
                });
            }
        },
        // 初始化待审核数据（可在mounted中调用）
        loadPendingApprovals() {
            // 调用API获取待审核列表
            this.$http.homeQueryAuditTask().then((res) => {
                if (res && res.status == 200) {
                    // 将API返回的数据转换为待审核任务格式
                    this.pendingApprovals = (res.result || []).map((item, index) => ({

                        businessId: item.businessId,
                        taskName: item.taskName,
                        createTime: item.createTime || new Date().toLocaleString(),
                        taskMode: item.taskMode,
                        targetPath: item.targetPath,
                    }))
                    // 如果有待审核任务，启动自动关闭定时器
                    if (this.pendingApprovals.length > 0) {
                        this.startApprovalAutoCloseTimer()
                    }
                } else {

                    this.$message({
                        message: res.message || '获取待审核任务失败',
                        type: "warning",
                    })

                }
            }).catch((error) => {
                console.error('获取待审核任务异常:', error)
                this.$message({
                    message: '获取待审核任务异常',
                    type: "error",
                })

            })
        },
        // 查询任务数量统计
        queryTaskNumber() {
            this.$http.homeQueryTaskNumber().then((res) => {
                if (res && res.status == 200) {
                    const auditTaskCount = res.result.auditTask || 0
                    console.log('待审核任务数量:', auditTaskCount)

                    // 如果有待审核任务且当前列表为空，则重新加载
                    if (auditTaskCount > 0 && this.pendingApprovals.length === 0) {
                        this.loadPendingApprovals()
                    }
                } else {
                    console.warn('获取任务统计失败:', res.message)
                }
            }).catch((error) => {
                console.error('获取任务统计异常:', error)
            })
        },

        // 加载待办事项数据
        loadPendingTodos() {
            // 调用API获取待办事项列表
            this.$http.homeQueryMyNeed().then((res) => {
                if (res && res.status == 200) {
                    // 将API返回的数据转换为待办事项格式
                    this.pendingTodos = (res.result || []).map((item, index) => ({
                        businessId: item.businessId,
                        businessType: item.businessType,
                        targetPath: item.targetPath,
                        createTime: item.createTime || new Date().toLocaleString(),
                        taskMode: item.taskMode,

                    }))
                    console.log('加载待办事项:', this.pendingTodos)
                    // 如果有待办事项，启动自动关闭定时器
                    if (this.pendingTodos.length > 0) {
                        this.startTodoAutoCloseTimer()
                    }
                } else {
                    console.warn('获取待办事项失败:', res.message)
                }
            }).catch((error) => {
                console.error('获取待办事项异常:', error)
            })
        },
    },
    beforeDestroy() {
        // 断开WebSocket连接
        this.disconnectWebSocket()
        this.noticeSetInterval = null
        // 清理弹窗自动关闭定时器
        if (this.approvalAutoCloseTimer) {
            clearTimeout(this.approvalAutoCloseTimer)
            this.approvalAutoCloseTimer = null
        }
        if (this.todoAutoCloseTimer) {
            clearTimeout(this.todoAutoCloseTimer)
            this.todoAutoCloseTimer = null
        }
    }, //生命周期 - 销毁之前

};
</script>
<style scoped>
.index_body {
    position: relative;
}

::v-deep .el-tabs__header {
    padding-right: 60px;
    padding-left: 10px;
    border-bottom: 2px solid #e4e7ed;
}

.tab_right {
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;
    height: 30px;
    z-index: 99;
    padding: 0 10px;
}

.el-dropdown-link:hover {
    color: #409eff;
    cursor: pointer;
}

::v-deep .el-dropdown-menu__item {
    padding: 0 5px;
    line-height: 25px;
}

.active {
    color: #409eff;
}

::v-deep .el-dropdown-menu__item .yes {
    display: inline-block;
    width: 20px;
}

::v-deep .el-dropdown-menu__item .icon {
    font-size: 16px;
    font-weight: 700;
}
</style>
<style>
.drawer-header {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 9999;
    display: flex;
    justify-content: flex-end;
}

.minimize-btn {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #d8d8d8;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: white;
    font-size: 14px;
    transition: all 0.3s ease;
}

.minimize-btn:hover {
    background: #409eff;
    transform: scale(1.1);
}

.minimized-drawer-float {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 9999;
    background: linear-gradient(135deg, #409eff, #67c23a);
    color: white;
    padding: 10px 15px;
    border-radius: 20px;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    font-size: 14px;
    transition: all 0.3s ease;
}

.minimized-drawer-float:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.minimized-drawer-float i {
    margin-right: 5px;
}

/* 其他现有样式 */
.home_iframe {
    width: 100%;
    height: 100%;
    border: 0;
    overflow: hidden;
    overflow-y: hidden;
    overflow: scroll;
}

.index_body_page {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.el-header {
    background-color: #b3c0d1;
    color: #fff;
    line-height: normal;
}

.el-aside {
    color: #333;
}

.el-tabs__header {
    height: 40px;
    margin: 0;
}

.el-tabs__content {
    flex: 1 !important;
}

/* .el-tabs__active-bar styles can be added here if needed */

.el-tabs__item {
    padding: 0 10px 0 10px !important;
}

.el-tabs__nav-wrap::after {
    border: none !important;
}

.nav-li {
    display: flex;
    align-items: center;
    font-size: 1rem;
    padding: 0 5px;
    height: 30px;
}

.nav-li .icon {
    font-size: 17px;
    font-weight: 500;
}

.nav-li span {
    white-space: nowrap;
    margin: 0;
}

.dia .el-dialog__header,
.dia .el-dialog__body {
    padding: 0 !important;
}

.right-menu {
    cursor: pointer;
    padding-right: 6px;
    height: 25px;
}

.right-menu img {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-bottom: 5px;
}

.button-box {
    width: 80px;
    border-radius: 50%;
    position: fixed;
    bottom: 57px;
    right: -35px;
    padding-left: 15px;
    padding-top: 8px;
    cursor: pointer;
    z-index: 888;
}

.btn-bg-img {
    width: 30px;
    height: 120px;
    background-color: #705fa1;
    background-size: cover;
    color: #fff;
    display: inline-flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 8px 2px 8px 6px;
    border-radius: 10px 0 0 10px;
    line-height: 20px;
}

.btn-bg-img1 {
    height: 140px;
}

.btn-bg-img:hover {
    opacity: 0.8;
}

.font-box {
    width: 80px;
    color: #3193ef;
    text-align: center;
}

/* .btn-bg-img img {
    margin-top: 10px;
    margin-left: 14px;
} */

/* 收藏b79860 */
.menu_title_osn .el-icon-star-off {
    opacity: 0;
}

.menu_title_osn .el-icon-star-on {
    opacity: 1;
    color: #999;
}

.menu_title_osn:hover .el-icon-star-off,
.menu_title_osn:hover .el-icon-star-on {
    color: #409eff;
    opacity: 1;
}

.menu_title_osn:hover {
    color: #409eff;
}

marquee {
    width: 100%;
}

.direc {
    height: 30px;
    width: 312px;
    font-size: 14px;
    margin-right: 5px;
    padding-top: 7px;
}

/* ------------------------- */
.name {
    padding: 0;
    margin: 0;
    font-weight: 600;
    height: 25px;
    font-size: 15px;
}

.title {
    font-size: 13px;
}

.imgLogo {
    display: flex;
    align-items: center;
    padding: 5px 0;
}

.imgLogo img {
    height: 30px;
    margin-right: 10px;
}

.imgLogo span:nth-child(2),
.imgLogo span:nth-child(4) {
    margin: 0;
    font-size: 15px;
    font-weight: 500;
}

.el-tabs__item {
    color: #6f6f6f;
}

/* 下拉菜单项右侧的关闭按钮：默认隐藏，悬浮菜单项时显示 */
.el-dropdown-menu__item .menu-close-icon {
    float: right;
    margin-left: 10px;
    line-height: 25px;
    opacity: 0;
    cursor: pointer;
    transition: opacity 0.2s;
}

.el-dropdown-menu__item:hover .menu-close-icon {
    opacity: 1;
}

.el-dropdown-menu__item .menu-close-icon:hover {
    color: #409eff;
}

/* tab设置下拉弹窗：固定右边缘定位，宽度变化（关闭标签后菜单变窄）时从左侧收缩，
   保证右侧的关闭叉号位置不动，可以连续点击关闭 */
.tab-setup-dropdown {
    left: auto !important;
    right: 10px !important;
}
</style>
<style scoped>
::v-deep .is-active {
    color: #409eff;
}

::v-deep .el-input__suffix {
    margin-right: 0;
}

.el-autocomplete {
    margin-right: 5px;
}

::v-deep .el-badge__content {
    font-size: 10px;
    border: none;
    height: 13px;
    line-height: 13px;
    padding: 0 2px;
    cursor: pointer;
    border-radius: 2px;
}

::v-deep .el-form-item {
    margin-bottom: 25px !important;
}

/* WebSocket通知相关样式 */
</style>
<style>
.notification-content {
    padding: 10px 0;
}

.notification-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #303133;
}

.notification-body {
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 10px;
    color: #606266;
    word-wrap: break-word;
}

.notification-time {
    font-size: 12px;
    color: #909399;
    text-align: right;
}

/* 待审核弹出层样式 */
.pending-approval-panel {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 350px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 9998;
    border: 1px solid #e4e7ed;
    overflow: hidden;
}

.panel-header {
    background: linear-gradient(135deg, #409eff, #67c23a);
    color: white;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
}

.panel-header i {
    margin-right: 8px;
    font-size: 16px;
}

.close-btn {
    color: white !important;
    padding: 4px !important;
    margin: 0 !important;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.close-btn:hover {
    background: rgba(255, 255, 255, 0.2) !important;
}

.close-btn:active {
    background: rgba(255, 255, 255, 0.3) !important;
}

.panel-content {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    scroll-behavior: smooth;
}

.approval-list {
    padding: 0;
}

.approval-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s;
}

.approval-item:hover {
    background-color: #f8f9fa;
}

.approval-item:last-child {
    border-bottom: none;
}

.item-info {
    flex: 1;
    margin-right: 12px;
}

.document-no,
.task-name {
    margin-bottom: 4px;
    font-size: 13px;
    line-height: 1.4;
}

.document-no .label,
.task-name .label {
    color: #909399;
    margin-right: 6px;
    font-weight: 500;
}

.document-no .value {
    color: #409eff;
    font-weight: 500;
    cursor: pointer;
}

.task-name .value {
    color: #303133;
}

.item-actions {
    flex-shrink: 0;
}

.panel-footer {
    padding: 8px 16px;
    background-color: #fafafa;
    border-top: 1px solid #f0f0f0;
    text-align: center;
}

.panel-footer .el-button {
    color: #409eff !important;
    font-size: 12px;
}

/* 滚动条样式 */
.panel-content::-webkit-scrollbar {
    width: 6px;
}

.panel-content::-webkit-scrollbar-track {
    background: #f8f9fa;
    border-radius: 3px;
}

.panel-content::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 3px;
    transition: background-color 0.2s;
}

.panel-content::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
}

.panel-content::-webkit-scrollbar-thumb:active {
    background: #6b7280;
}

/* 待办事项弹出层样式 */
.pending-todo-panel {
    position: fixed;
    bottom: 360px;
    /* 放在待审核弹窗上方 */
    right: 20px;
    width: 350px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 9997;
    /* 比待审核弹窗低一层 */
    border: 1px solid #e4e7ed;
    overflow: hidden;
}

.pending-todo-panel .panel-header {
    background: linear-gradient(135deg, #f39c12, #e67e22);
    color: white;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
}

.pending-todo-panel .panel-header i {
    margin-right: 8px;
    font-size: 16px;
}

.pending-todo-panel .close-btn {
    color: white !important;
    padding: 4px !important;
    margin: 0 !important;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.pending-todo-panel .close-btn:hover {
    background: rgba(255, 255, 255, 0.2) !important;
}

.pending-todo-panel .close-btn:active {
    background: rgba(255, 255, 255, 0.3) !important;
}

.pending-todo-panel .panel-content {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    scroll-behavior: smooth;
}

.todo-list {
    padding: 0;
}

.todo-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s;
}

.todo-item:hover {
    background-color: #f8f9fa;
}

.todo-item:last-child {
    border-bottom: none;
}

.todo-item .item-info {
    flex: 1;
    margin-right: 12px;
}

.todo-item .item-actions {
    flex-shrink: 0;
}

/* 待办事项滚动条样式 */
.pending-todo-panel .panel-content::-webkit-scrollbar {
    width: 6px;
}

.pending-todo-panel .panel-content::-webkit-scrollbar-track {
    background: #f8f9fa;
    border-radius: 3px;
}

.pending-todo-panel .panel-content::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 3px;
    transition: background-color 0.2s;
}

.pending-todo-panel .panel-content::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
}

.pending-todo-panel .panel-content::-webkit-scrollbar-thumb:active {
    background: #6b7280;
}

/* WebSocket消息通知弹出层样式 */
.notification-panel {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 400px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 9999;
    /* 最高层级，覆盖其他弹窗 */
    border: 1px solid #e4e7ed;
    overflow: hidden;
}

.notification-panel .panel-header {
    background: linear-gradient(135deg, #409eff, #67c23a);
    color: white;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
}

.notification-panel .panel-header i {
    margin-right: 8px;
    font-size: 16px;
}

.notification-panel .close-btn {
    color: white !important;
    padding: 4px !important;
    margin: 0 !important;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.notification-panel .close-btn:hover {
    background: rgba(255, 255, 255, 0.2) !important;
}

.notification-panel .close-btn:active {
    background: rgba(255, 255, 255, 0.3) !important;
}

.notification-panel .panel-content {
    padding: 8px;
}

.notification-panel .notification-body {
    font-size: 14px;
    line-height: 1.5;
    color: #333;
    margin-bottom: 12px;
}

.notification-panel .notification-time {
    font-size: 12px;
    color: #999;
    text-align: right;
}

.notification-panel .panel-footer {
    padding: 12px 16px;
    background: #f8f9fa;
    border-top: 1px solid #e4e7ed;
    text-align: right;
}

.notification-panel .panel-footer .el-button {
    margin-left: 8px;
}

/* WebSocket消息信息样式 */
.notification-panel .message-info {
    padding: 0;
}

.notification-panel .info-item {
    display: flex;
    margin-bottom: 8px;
    align-items: flex-start;
}

.notification-panel .info-item:last-child {
    margin-bottom: 0;
}

.notification-panel .info-item .label {
    font-weight: 500;
    color: #666;
    min-width: 80px;
    flex-shrink: 0;
}

.notification-panel .info-item .value {
    color: #333;
    flex: 1;
    word-break: break-all;
}

.notification-panel .simple-message {
    color: #333;
    line-height: 1.5;
}
.penetrateCashier {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
}
</style>